(function(args) { 
	
	document.getElementById(args.id).innerHTML = `
		<div class="form-field search-filter project-search-filter project-search-filter-search">
			<input type="text" id="form_projects_front_field_search" placeholder="Type to filter.." />
		</div>
	`;

	document.addEventListener('DOMContentLoaded', function() { 

		var field_search_value = document.getElementById('form_projects_field_search').value;
		document.getElementById('form_projects_front_field_search').value = field_search_value;

		document.addEventListener('input', function(e) { 
			if (e.target.matches('#form_projects_front_field_search')) {
				document.getElementById('form_projects_field_search').value = e.target.value;
			} 
		});
	});
})(args);